import styles from './FormFooter.module.css';
import { IconButton } from './IconButton';
import { IconCheck, IconClose } from './QuirkIcons';

export interface FormFooterProps {
	onSubmit: () => void;
	onCancel: () => void;
	disableSubmit?: boolean;
	disableCancel?: boolean;
	submitIcon?: JSX.Element;
	cancelIcon?: JSX.Element;
	submitLabel?: string;
	cancelLabel?: string;
}

export default function FormFooter({
	onSubmit,
	onCancel,
	disableSubmit,
	disableCancel,
	submitIcon = <IconCheck />,
	cancelIcon = <IconClose />,
	submitLabel = 'Done',
	cancelLabel = 'Cancel'
}: FormFooterProps): JSX.Element {
	return (
		<div className={styles.FormFooter}>
			<IconButton label={cancelLabel} disabled={disableCancel} icon={cancelIcon} onClick={onCancel} />
			<IconButton
				fill="solid"
				label={submitLabel}
				disabled={disableSubmit}
				icon={submitIcon}
				onClick={onSubmit}
			/>
		</div>
	);
}
